export const decodeAccessToken = (accessToken: string) => {
  const base64Url = accessToken.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}

export const writeTokenActions = ({ accessToken, idToken, refreshToken }: Record<string, string>) => {
  if (accessToken) {
    const decoded = decodeAccessToken(accessToken)
    localStorage.setItem('yld_a_token_timeout', decoded.exp)
  }

  idToken && localStorage.setItem('yld_i_token', idToken)
  refreshToken && localStorage.setItem('yld_r_token', refreshToken)
}
